import {
  FULFILLMENT_ERROR,
  GET_FULFILLMENT_CONTACT,
  GET_FULFILLMENT,
  EDIT_FULFILLMENT_SUCCESS,
} from "../constants/fulfillmentConstants";

const initialState = {
  fulfillment: null,
  loading: true,
};

export const requestFulfillment = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_FULFILLMENT:
      return Object.assign({}, state, {
        fulfillment: action.payload,
        loading: false,
      });
    case FULFILLMENT_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export const requestFulfillmentContact = (
  state = initialState,
  action = {}
) => {
  switch (action.type) {
    case GET_FULFILLMENT_CONTACT:
      return Object.assign({}, state, {
        fulfillment: action.payload,
        loading: false,
      });
    case FULFILLMENT_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const editFulfillment = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_FULFILLMENT_SUCCESS:
      return Object.assign({}, state, {
        fulfillment: action.payload,
      });
    default:
      return state;
  }
};
